/* eslint-disable import/no-unresolved */
import { Helmet } from 'react-helmet-async';
import { useDevice } from 'hooks/useResponsive';

import InspectionPageMobile from './InspectionMobile';
import InspectionPageWeb from './InspectionWeb';

export default function Inspection() {
  const { isMobile } = useDevice();

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What does a pre-purchase car inspection include?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We check the engine, transmission, brakes, suspension, electrical systems, body and structure for accident history, tyres, interior features, and documentation such as service history and odometer accuracy — 130+ points in total.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long does the inspection take?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Most inspections are completed within 1-2 hours depending on the vehicle and condition, with the report typically delivered within a few hours after the inspection.',
        },
      },
      {
        '@type': 'Question',
        name: 'Can I be present during the inspection?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: "Yes. Buyers are encouraged to be present during the inspection to ask questions and see the car's condition firsthand.",
        },
      },
      {
        '@type': 'Question',
        name: 'Do you inspect cars anywhere in Kerala?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, pre-purchase car inspection services are offered across all of Kerala.',
        },
      },
      {
        '@type': 'Question',
        name: 'What if the inspection finds problems?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Buyers receive a detailed report with photos of any issues found, which can be used to negotiate the price or decide whether to proceed with the purchase.',
        },
      },
      {
        '@type': 'Question',
        name: 'How much does a pre-purchase inspection cost?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Two packages are available: Normal Inspection at ₹4,999 and Premium Inspection at ₹7,999, with the recommended package depending on car type.',
        },
      },
    ],
  };

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Pre-Purchase Car Inspection',
    provider: { '@type': 'Organization', name: 'Focus Motors', url: 'https://focusmotors.in' },
    areaServed: { '@type': 'State', name: 'Kerala' },
    url: 'https://focusmotors.in/inspection',
    description:
      '130+ point pre-purchase car inspection service covering engine, electrical, brakes, body, and documentation checks, available across all of Kerala.',
    offers: [
      {
        '@type': 'Offer',
        name: 'Normal Inspection',
        price: '4999',
        priceCurrency: 'INR',
        url: 'https://focusmotors.in/inspection-booking',
      },
      {
        '@type': 'Offer',
        name: 'Premium Inspection',
        price: '7999',
        priceCurrency: 'INR',
        url: 'https://focusmotors.in/inspection-booking',
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>Pre-Purchase Car Inspection in Kerala | Focus Motors</title>
        <meta name="google-site-verification" content="iOIVKOuZeIpVu0rC0hha2Dt6hCT9HyWE4cRqm-Y1y2E" />
        <meta
          name="description"
          content="130+ point pre-purchase car inspection across Kerala. Normal ₹4,999, Premium ₹7,999. Book your inspection today with Focus Motors."
        />
        <meta
          name="keywords"
          content="pre-purchase car inspection Kerala, used car inspection Kerala, car inspection before buying, vehicle inspection Kerala, Focus Motors inspection"
        />
        <link rel="canonical" href="https://focusmotors.in/inspection" />
        <meta property="og:title" content="Pre-Purchase Car Inspection in Kerala | Focus Motors" />
        <meta
          property="og:description"
          content="130+ point pre-purchase car inspection across Kerala. Normal ₹4,999, Premium ₹7,999."
        />
        <meta property="og:url" content="https://focusmotors.in/inspection" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-GLBNLL77TW" />
        <script>{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-GLBNLL77TW');
        `}</script>
      </Helmet>
      <div>{isMobile ? <InspectionPageMobile /> : <InspectionPageWeb />}</div>
    </>
  );
}
